<template>
  <tm-button
    class="tm-sidebar-header-button"
    :disable="disabled"
    icon-only
    color="transparent"
    no-border
    size="medium"
    flat
    :to="to"
  >
    <tm-icon
      :name="icon"
      :class="iconClass"
      size="large"
    />
    <tm-new-dot
      v-if="showDot"
      small-button
    >
      <tm-icon
        v-if="showWarning"
        v-bind="warningIcon"
      />
    </tm-new-dot>
  </tm-button>
</template>

<script setup lang="ts">
import type { RouteLocationNamedRaw } from 'vue-router'
import { watchEffect } from '@/composition/vue/compositionApi'
import TmButton from '@/components/shared/TmButton.vue'
import TmIcon from '@/components/shared/TmIcon.vue'
import TmNewDot from '@/components/shared/TmNewDot.vue'
import type { IconName } from '@/assets/icons/icons'
import type { VueLikeClassAttr } from '@/components/types'
import type { TmIconType } from '@/components/shared/types'
import { useRoutePrefetch } from '@/composition/useRoutePrefetch'

const props = defineProps<{
  icon: IconName
  to?: RouteLocationNamedRaw
  iconClass?: VueLikeClassAttr
  disabled?: boolean
  showDot?: boolean
  showWarning?: boolean
}>()

const warningIcon: TmIconType = {
  name: 'warning',
  size: 'medium',
  class: 'orange--text',
  style: { bottom: '3px', left: '1px' },
}

watchEffect(() => {
  if (props.to) {
    useRoutePrefetch([props.to])
  }
})
</script>

<style lang="scss" scoped>
.tm-sidebar-header-button {
  justify-content: center;
}
</style>
